import React from 'react'
import '../../StoreDashboard/style.css'
import OrderListByProductsTable from '../../../../components/Widgets/Tables/OrderListByProductsTable'

const ProductOrdersPage = () => {
  return (
    <div className="outlet-container">
      <OrderListByProductsTable />
    </div>
  )
}

export default ProductOrdersPage
